import { PollOption } from 'model';

export const updateKeyInPollOptions = (
	pollOptions: PollOption[],
	targetKey: string,
	newValue: string
): PollOption[] => {
	return pollOptions.map(option => {
		if (option.key === targetKey) {
			return { ...option, value: newValue };
		}
		return option;
	});
};
